import { add_to_cart } from './../../vue'

export default {
	namespace: 'product',
	beforeEnter() {

	},
	afterEnter() {

		// Load Add To Cart Vue Instance
		add_to_cart()

	},
	beforeLeave() {

	},
	afterLeave() {

	}
}
